module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"professional-occupation":"Área de atuação ou função desempenhada"},"en-US":{"professional-occupation":"Area of activity or function performed"}}')
  delete Component.options._Ctor
}
